import { render } from "./AccountChangePassword.vue?vue&type=template&id=24e62b41&ts=true"
import script from "./AccountChangePassword.vue?vue&type=script&lang=ts"
export * from "./AccountChangePassword.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__